export function preloaderAnimation() {
    const $body = $("body");
    const $window = $(window);
    let $section = $(".section")
    $body.addClass("start-preloader-js")
    setTimeout(function () {
        $body.addClass("show-page-js")
    }, 2200);

    function heroSectionLogo() {
        if ($(".hero-section").length) {
            if ($window.scrollTop() > 0 && $window.innerWidth() >= 1180 && $body.hasClass("show-page-js")) {
                $(".hero-section .video-animation-wrap").addClass("show");
            }
            let nextSction = $(".hero-section").next(".section");
            let nextSctionoffset = nextSction.offset().top;
            if ($window.scrollTop() + $window.innerHeight() > nextSctionoffset) {
                $(".hero-logo").addClass("absolute");
            } else {
                $(".hero-logo").removeClass("absolute");
            }
        }
    }

    function bodyBackground() {
        $section.each(function (i, it) {
            let backgroundColor = $(it).data("color");
            let sectionOffset = $(it).offset().top;
            if ($window.scrollTop() > sectionOffset - $window.innerHeight() * 0.55 && !$(it).hasClass("active")) {
                $body.css({
                    "background-color": backgroundColor
                });
                $(it).addClass("active").css({
                    "background-color": backgroundColor
                });
            }
        });
    }

    $(window).on("scroll load", function () {
        heroSectionLogo();
        bodyBackground();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/preloaderAnimation.js